export default function getTaskActivityURL(taskId, taskActivity) {
  const { activityId, activityConf, id: taskActivityId } = taskActivity;

  const miniactivityConf = getMiniactivityConf(activityConf);

  const queryParams = {
    taskActivityParams: JSON.stringify({
      taskId,
      activityId,
      taskActivityId,
      miniactivityConf,
    }),
  };
  const queryString = new URLSearchParams(queryParams).toString();

  return `/student/tasks/${taskId}?${queryString}`;
}

function getMiniactivityConf(activityConf) {
  return {
    miniactivityType: activityConf.miniactivityType,
    level: activityConf.options?.level || 'easy',
    themes: activityConf.themes,
  };
}
